var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Menu")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/LP"}},[_vm._v("Large Panels")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/SP"}},[_vm._v("Small Panels")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/CR"}},[_vm._v("Comparison Report")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abb4700","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = null
// module chunks = 